import { mkhctokenEventType } from "./dispatchSignInInfoEvent";
import { SignInInfo } from "./normalizeSigninResponse";

/**
 * @returns for unit test snapshot only
 */
export function setSignInInfo(
  // eslint-disable-next-line @typescript-eslint/prefer-readonly-parameter-types
  signInInfo: SignInInfo
): unknown {
  return sessionStorage.setItem(mkhctokenEventType, JSON.stringify(signInInfo));
}
